<div [ngStyle]="themeCssVars()">
  @if (showAdminShell()) {
  <div class="h-screen overflow-hidden text-slate-800 bg-slate-50">
    @if (trialBannerMessage(); as trialMessage) {
    <div
      class="fixed inset-x-0 top-0 z-[80] flex h-10 items-center justify-center border-b border-sky-200 bg-sky-100 px-3 text-center text-sm font-medium text-sky-800"
      role="status"
    >
      {{ trialMessage }}
    </div>
    } @if (!isNavbarLayout()) {
    <app-sidebar
      [isOpen]="isSidebarOpen()"
      [topOffset]="shellTopOffset()"
      (closeSidebar)="onCloseSidebar()"
      [navItems]="navbarItems()"
    />

    <button
      type="button"
      class="fixed z-[70] hidden size-5 -translate-y-1/2 items-center justify-center rounded-full border border-white/30 bg-white text-slate-700 shadow-sm outline-none transition-all duration-300 ease-in-out hover:bg-slate-50 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 active:outline-none lg:inline-flex"
      [style.top]="sidebarToggleTop()"
      [ngClass]="{
          'left-[calc(300px-0.625rem)]': isSidebarOpen(),
          'left-[calc(4rem-0.625rem)]': !isSidebarOpen(),
        }"
      (click)="onToggleSidebar()"
      [attr.aria-expanded]="isSidebarOpen()"
      aria-controls="application-sidebar"
      aria-label="Alternar sidebar"
    >
      <span class="sr-only">Alternar sidebar</span>
      <i
        class="bi bi-chevron-left text-xs leading-none"
        aria-hidden="true"
        [class.rotate-180]="!isSidebarOpen()"
      ></i>
    </button>

    @if (isSidebarOpen()) {
    <div
      class="fixed inset-0 z-50 bg-slate-900/40 backdrop-blur-sm transition-opacity lg:hidden"
      [style.top]="shellTopOffset()"
      (click)="onToggleSidebar()"
      aria-hidden="true"
    ></div>
    } }

    <div
      class="relative flex h-full min-w-0 flex-col transition-all duration-300"
      [ngClass]="{
          'lg:ms-[300px]': !isNavbarLayout() && isSidebarOpen(),
          'lg:ms-16': !isNavbarLayout() && !isSidebarOpen(),
        }"
    >
      <app-header
        [sidebarCollapsed]="!isSidebarOpen()"
        [navigationLayout]="navigationLayout()"
        [topOffset]="shellTopOffset()"
        [title]="headerTitle()"
        [userName]="userName()"
        [userRoleLabel]="userRoleLabel()"
        [loginCandidates]="loginCandidates()"
        [currentUserId]="currentUserId()"
        (toggleSidebar)="onToggleSidebar()"
        (logout)="onLogout()"
        (switchUser)="onSwitchUser($event)"
      />

      @if (isNavbarLayout()) {
      <app-navbar [navItems]="navbarItems()" [topOffset]="navbarTop()" />
      }

      <main
        class="min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-contain p-3 sm:p-4 lg:p-6"
        [style.margin-top]="mainContentTop()"
      >
        <router-outlet />
      </main>
    </div>
  </div>
  } @else {
  <router-outlet />
  }
</div>
